import { render, staticRenderFns } from "./dealsOverview.vue?vue&type=template&id=1b071b24&lang=pug"
import script from "./dealsOverview.vue?vue&type=script&lang=js"
export * from "./dealsOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports